var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_14774)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7143 10.2857V13.7143C21.7143 14.5603 21.2546 15.299 20.5714 15.6942V18.2857C20.5714 19.5481 19.5481 20.5714 18.2857 20.5714H4.57142C3.30905 20.5714 2.28571 19.5481 2.28571 18.2857V5.71427C2.28571 4.45191 3.30905 3.42856 4.57142 3.42856H18.2857C19.5481 3.42856 20.5714 4.45191 20.5714 5.71427V8.30577C21.2546 8.70098 21.7143 9.43966 21.7143 10.2857ZM6.85713 6.85713C6.22595 6.85713 5.71428 7.3688 5.71428 7.99999C5.71428 8.63117 6.22595 9.14284 6.85713 9.14284H16C16.6312 9.14284 17.1428 8.63117 17.1428 7.99999C17.1428 7.3688 16.6312 6.85713 16 6.85713H6.85713ZM16 13.7143C16.6312 13.7143 17.1428 13.2026 17.1428 12.5714C17.1428 11.9402 16.6312 11.4286 16 11.4286C15.3688 11.4286 14.8571 11.9402 14.8571 12.5714C14.8571 13.2026 15.3688 13.7143 16 13.7143Z",
    fill: "#482701"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_14774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.4799b6a7c6e1a7ae38846d446a66e649.svg";
export { ForwardRef as ReactComponent };